<template></template>
<script>
export default {
  data() {
    return {
      userInfo: "",
      userName: "",
      cliHeight: 0,
       InitHeight: $(document.body).outerHeight(true),
    };
  },
  methods: {
    waterMark$() {
      if (
        navigator.appName == "Microsoft Internet Explorer" &&
        navigator.appVersion.match(/11./i) != "11."
      ) {
        $("p[name='p1$']").remove();
        var winwidth$ = document.body.scrollWidth - 17;
        var winheight$ = document.body.scrollHeight;
        $("body").append(
          `<p id='waterSum_11' name='p1$' class='cover_through cover js-click-to-alert'>${this.userName}</p>`
        );
        var fleft = Number(
          $("#waterSum_11")
            .css("margin-left")
            .substring(0, $("#waterSum_11").css("margin-left").indexOf("p"))
        );
        var ftop = Number(
          $("#waterSum_11")
            .css("margin-top")
            .substring(0, $("#waterSum_11").css("margin-top").indexOf("p"))
        );
        var perWidth = $("#waterSum_11").width();
        var perHeight =
          Number("140px".substring(0, "140px".indexOf("p"))) + 100;
        var lines = parseInt(winwidth$ / (perWidth + fleft));
        var rows = Math.round(winheight$ / (perHeight + ftop));
        var totalPWidth = perWidth * lines;
        var totalSpace = winwidth$ - totalPWidth;
        var perSpace = parseInt(totalSpace / (lines + 1));
        $("#waterSum_11").css("margin-left", perSpace);
        for (var i = 1; i <= rows; i++) {
          for (var j = 1; j <= lines; j++) {
            if (i == 1) {
              if (j <= lines - 1) {
                var p =
                  "<p id='waterSum_" +
                  i +
                  "" +
                  (j + 1) +
                  `' name='p1$' class='cover_through cover js-click-to-alert'>${this.userName}</p>`;
                var ileft = $("#waterSum_" + i + "" + j)
                  .css("margin-left")
                  .substring(
                    0,
                    $("#waterSum_" + i + "" + j)
                      .css("margin-left")
                      .indexOf("p")
                  );
                var itop = $("#waterSum_11")
                  .css("margin-top")
                  .substring(
                    0,
                    $("#waterSum_11").css("margin-top").indexOf("p")
                  );
                $("body").append(p);
                $("#waterSum_" + i + "" + (j + 1)).css(
                  "margin-left",
                  Number(ileft) + Number(perWidth) + perSpace
                );
                $("#waterSum_" + i + "" + (j + 1)).css("margin-top", itop);
              }
            } else {
              var p =
                "<p id='waterSum_" +
                i +
                "" +
                j +
                "' name='p1$' class='cover_through cover js-click-to-alert'>${TmpContent}</p>";
              var ileft = $("#waterSum_" + (i - 1) + "" + j)
                .css("margin-left")
                .substring(
                  0,
                  $("#waterSum_" + (i - 1) + "" + j)
                    .css("margin-left")
                    .indexOf("p")
                );
              var itop = $("#waterSum_" + (i - 1) + "" + j)
                .css("margin-top")
                .substring(
                  0,
                  $("#waterSum_" + (i - 1) + "" + j)
                    .css("margin-top")
                    .indexOf("p")
                );
              $("body").append(p);
              $("#waterSum_" + i + "" + j).css("margin-left", Number(ileft));
              $("#waterSum_" + i + "" + j).css(
                "margin-top",
                Number(itop) + Number(perHeight)
              );
            }
          }
        }
        this.passThrough();
      } else {
        this.waterMarkNotIe$(this.InitHeight);
      }
    },
    waterMarkNotIe$(InitHeight) {
      $(".cover-Blink-area").remove();
      var winwidth$ = document.body.clientWidth;
      var winheight$ = document.body.scrollHeight + window.innerHeight;
      var waterSum$ = 100;
      var oldleft$ = 0;
      var maxI$ = 0;
      var k$ = 0;
      $("body").append("<div class='cover-Blink-area'> </div>");
      this.$nextTick(() => {
        $(".cover-Blink-area").css("height",InitHeight)
      
        for (var i = 1; i <= waterSum$; i++) {
          $(".cover-Blink-area").append(
            "<p id='waterSum_" +
              i +
              `' class='cover_through cover-Blink js-click-to-alert'>${this.userName}</p>`
          );
          var left = Number(
            document.getElementById("waterSum_" + i).offsetLeft
          );
          if (left > oldleft$) {
            oldleft$ = left;
            maxI$ = i;
          }
          if (left < oldleft$ && k$ == 0) {
            var top = $("#waterSum_1")
              .css("margin-top")
              .substring(0, $("#waterSum_1").css("margin-top").indexOf("p"));
            var bottom = $("#waterSum_1")
              .css("margin-bottom")
              .substring(0, $("#waterSum_1").css("margin-bottom").indexOf("p"));
            var pHeight = $("#waterSum_1").height();
            var totalHeight = Number(top) + Number(pHeight) + Number(bottom);
            var Hnum = Math.round(1500 / (totalHeight / 1.3));
            waterSum$ = Hnum * maxI$;
            k$++;
          }
        }
      });
    },
    getUserInfo() {
      if (sessionStorage.userInfo != undefined) {
        const user = JSON.parse(sessionStorage.userInfo);
        this.userName = user.name + " " + user.wwid;
      }
    },
     loadFun() {
      if (!this.timer) {
        this.timer = true;
        let that = this;
        setTimeout(function () {
          that.timer = false;
            that.InitHeight=$(document.body).outerHeight(true)
            console.log(that.InitHeigh);
        }, 800);
      }
    },
    passThrough() {
      $(".cover").mouseenter(function () {
        $(this).stop(true).fadeOut().delay(1500).fadeIn(50);
      });
    },
  },
  created() {
    this.getUserInfo();
  },
  mounted() {
    if (this.$route.path == "/index") {
      this.loadFun();
    } else if (this.$route.path == "/indexSec") {
      this.loadFun();
    } else if (this.$route.path == "/indexThr") {
      this.loadFun();
    } else if (this.$route.path == "/indexFor") {
      this.loadFun();
    }
  },
  watch: {
  InitHeight (val) {
    this.innerHeight=val
    this.waterMark$(this.innerHeight);
   }
  }
 }

</script>
<style>
.cover {
  /* position: absolute; */
  left: 0;
  top: 0;
  z-index: 999999999999999;
  margin-right: 0px;
  margin-left: 0px;
  margin-top: 5px;
  margin-bottom: 140px;
  color: #fff;
  color: #ccc;
  display: block;
  padding: 2px 1px;
  font-family: "宋体";
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
  text-shadow: 1px 0 0 #eee;
  transform: rotate(-25deg);
  -ms-transform: rotate(-25deg);
  -moz-transform: rotate(-25deg);
  -webkit-transform: rotate(-25deg);
  -o-transform: rotate(-25deg);
  -moz-opacity: 0.3;
  opacity: 0.3;
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(M11=0.7071067811865474, M12=-0.7071067811865477, M21=0.7071067811865477, M22=0.7071067811865474, SizingMethod='auto expand')";
}
.cover-Blink-area {
  position: absolute;
  text-align: center;
  left: 0;
  top: 0;
  width: 100%;
  display: block;
  z-index: 999999999999999;
  opacity: 0.4;
  pointer-events: none;
  overflow: hidden;
  min-height: 100%;
}
.cover-Blink {
  display: inline-block;
  margin: 120px 50px 80px;
  padding: 2px 1px;
  font-family: "PingFangSC-Regular";
  font-size: 16px;
  font-weight: bold;
  color: #919191;
  opacity: 0.4;
  white-space: nowrap;
  text-shadow: 1px 0 0 rgba(0, 0, 0, 0.2);
  transform: rotate(-25deg);
  -ms-transform: rotate(-25deg);
  -moz-transform: rotate(-25deg);
  -webkit-transform: rotate(-25deg);
  -o-transform: rotate(-25deg);
}
</style>


// WEBPACK FOOTER //
// src/components/public/mask.vue